<template>
  <!-- TOP BAR -->
  <v-toolbar elevation="8" class="bg_opacity fixed">
    <v-spacer></v-spacer>
    <v-app-bar-nav-icon
        class="d-flex d-md-none text-white"
        @click="drawer = true"
    />

    <router-link to="/" class="text-decoration-none">
      <v-app-bar-title class="text-white text-h5">
        АНО Ответ
      </v-app-bar-title>
    </router-link>

    <v-spacer />

    <!-- DESKTOP MENU -->
    <div class="d-none d-md-flex">
      <template v-for="item in menu" :key="item.id">

        <!-- SIMPLE LINK -->
        <router-link
            v-if="!item.children"
            :to="item.link"
            class="text-white px-4 py-2 text-decoration-none"
        >
          {{ item.title }}
        </router-link>

        <!-- DROPDOWN -->
        <v-menu v-else offset-y>
          <template #activator="{ props }">
            <div v-bind="props" class="px-4 py-2 d-flex align-center cursor-pointer text-white">
              {{ item.title }}
              <v-icon size="small" class="ml-1">mdi-chevron-down</v-icon>
            </div>
          </template>

          <v-list density="compact">
            <v-list-item
                v-for="child in item.children"
                :key="child.id"
                :to="child.link"
                :active="isActive(child)"
            >
              <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>
    <v-spacer />
  </v-toolbar>

  <!-- MOBILE DRAWER -->
  <v-navigation-drawer v-model="drawer" temporary>
    <v-list>
      <template v-for="item in menu" :key="item.id">

        <!-- SIMPLE LINK -->
        <v-list-item
            v-if="!item.children"
            :to="item.link"
            @click="closeDrawer"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>

        <!-- ACCORDION -->
        <div v-else>
          <v-list-item @click="toggle(item.id)" :active="isChildActive(item.children)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>

            <template #append>
              <v-icon :class="{ 'rotate-180': isOpen(item.id) }">
                mdi-chevron-down
              </v-icon>
            </template>
          </v-list-item>

          <v-expand-transition>
            <div v-show="isOpen(item.id)">
              <v-list-item
                  v-for="child in item.children"
                  :key="child.id"
                  :to="child.link"
                  class="pl-6"
                  @click="closeDrawer"
                  :active="isActive(child)"
              >
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-expand-transition>
        </div>

      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { ref, watchEffect } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const drawer = ref(false)
const openId = ref(null)

const menu = [
  {
    id: 1,
    title: 'О нас',
    children: [
      { id: 16, title: 'Анкета для получения помощи', link: '/form' },
      { id: 13, title: 'Как мы помогаем', link: '/help' },
      { id: 7, title: 'Представители', link: '/representatives' },
      { id: 8, title: 'Документы', link: '/documents' }
    ]
  },
  {
    id: 2,
    title: 'Проекты',
    children: [
      { id: 14, title: 'Мастерская взрослой жизни', link: '/projects/masterskaya-vzrosloy-zhizny' },
      { id: 17, title: 'Маленькие радости', link: '/projects/malenkije-radosty' },
      { id: 9, title: 'Дом милосердия', link: '/projects/dom-miloserdija' }
    ]
  },
  {
    id: 3,
    title: 'Отчёты',
    children: [
      { id: 11, title: 'Годовой отчёт', link: '/reports/2026' },
      { id: 12, title: 'Итоги работы', link: '/reports/itogi-raboti' }
    ]
  },
  { id: 4, title: 'Партнёры', link: '/partners' },
  { id: 5, title: 'Новости', link: '/news' },
  { id: 6, title: 'Контакты', link: '/contacts' }
]

const isActive = (link) => {
  if (!link) return false
  return route.path === link || route.path.startsWith(link + '/')
}

const isChildActive = (children) => {
  if (!children) return false
  return children.some(child =>
      route.path === child.link || route.path.startsWith(child.link + '/')
  )
}

watchEffect(() => {
  const activeParent = menu.find(item =>
      item.children && isChildActive(item.children)
  )

  if (activeParent) {
    openId.value = activeParent.id
  }
})

const toggle = (id) => {
  openId.value = openId.value === id ? null : id
}

// открыт ли пункт
const isOpen = (id) => openId.value === id

// закрыть drawer
const closeDrawer = () => {
  drawer.value = false
  openId.value = null
}
</script>

<style scoped>
.bg_opacity {
  background: rgb(92, 187, 246);
}

.fixed {
  position: fixed;
  z-index: 1000;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
</style>
